module.exports = __webpack_public_path__ + "Simple-Line-Icons.d2285965fe34b0546504.ttf";


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/assets/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module chunks = styles